<template>
    <div>
        <v-row class="px-2">
            <v-col md="12" class="pa-2" align="center">
                <chart
                    v-if="chartData && chartData.length"
                    ref="chart"
                    :chartData="chartData"
                ></chart>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import Chart from '@/components/reports/charts/Last30DaysTransactions.vue';

export default {
    components: {
        'chart': Chart,
    },
    data() {
        return {
            chartData: null
        }
    },
    beforeMount() {
        this.getChart();
    },
    methods: {
        getChart() {
            axios({
            method: 'get',
            url: 'earth2-last-30-days-transactions',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>